export default __webpack_public_path__ + "static/media/Pitfighter's Battle Cache.2f3426f8.jpg";